module.exports = __webpack_public_path__ + "img/img_bottom.4a72dee3.png";